import { useEffect, useState } from "react";
import { loadEditorUI, type WebEditorUI } from "../registry/editorRegistry";

// Lazy-Loader für die EditorUI (D66, analog useToolUI/D16): lädt das per-Editor `ui.tsx`-
// Modul on-demand und hält es im State. Solange es lädt → `loading`; kein Loader registriert
// → `undefined` (die Shell zeigt dann leere Regionen / einen Hinweis). Race-safe via `active`.
export function useEditorUI(editorId: string | undefined): { ui: WebEditorUI | undefined; loading: boolean } {
  const [ui, setUi] = useState<WebEditorUI | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(Boolean(editorId));

  useEffect(() => {
    if (!editorId) {
      setUi(undefined);
      setLoading(false);
      return;
    }
    let active = true;
    setUi(undefined); // beim Wechsel sofort die alte UI verwerfen (kein Stale-Render)
    setLoading(true);
    void loadEditorUI(editorId)
      .then((loaded) => {
        if (active) setUi(loaded);
      })
      .catch(() => {
        // Chunk-Load-Fehler → kein Dauer-Loading; Shell zeigt leere Regionen.
        if (active) setUi(undefined);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [editorId]);

  return { ui, loading };
}
